import { BackendModelKey } from '@/core/enums/backendModel';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import permissionService from './permission.service';

export interface PermissionState { }

const PermissionStore: Module<PermissionState, StoreState> = {
   namespaced: true,
   state: {},

   getters: {},

   mutations: {},

   actions: {
      async postBulk(
         context,
         { resource_type, resource_id, actions }: { resource_type: BackendModelKey; resource_id: number; actions: string[] },
      ) {
         if (actions?.length === 0) return;
         const BODY = {
            resource_type,
            resource_id,
            actions,
         };

         return await permissionService.postBulk(BODY).then((permissions) => {
            if (resource_type == BackendModelKey.pool) {
               context.commit('pool/setPoolPermissions', { permissions }, { root: true });
            } else if (resource_type == BackendModelKey.board) {
               context.commit('board/setBoardPermissions', { permissions }, { root: true });
            }
         });
      },
   },
};

export default PermissionStore;
